import * as svg from "../../../assets/dollar-icon.svg";

import {iconBuilder} from "./iconBuilder";

const DollarIcon = iconBuilder(svg, "DollarIcon", "0 0 14 15");

export default DollarIcon;
